<template>
  <div>
    <el-main>
      <el-dialog
        width="30%"
        title="新增分类"
        :visible.sync="dialogFormVisible"
        append-to-body>
        <el-form :model="form">
          <el-form-item label="类型名称" :label-width="formLabelWidth">
            <el-input v-model="innertypename" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addLabel">确 定</el-button>
        </div>
      </el-dialog>

    <div style="padding: 10px 0px;text-align: right;">
      <el-button type="primary" @click="addQuestion">新增</el-button>
    </div>
    <el-table id="dataTable" :data="dataList" :border="border" :height="tableHeight"
              style="height:auto;" :header-cell-style="tableHeaderColor">
      <el-table-column header-align="center" align="center"  prop="labelId" label="编号" width="" ></el-table-column>
      <el-table-column header-align="center" prop="labelName" label="标签" ></el-table-column>
<!--      <el-table-column header-align="center" align="center" label="操作" width="" >-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="mini" type="primary" style="color: #FFFFFF"  @click="changeQaInfo(scope.row)">修改</el-button>-->
<!--          <el-button size="mini" :class="scope.row.sProcessingStatus === '未处理' ? 'activecolor' : 'grey'"  @click="open(scope.row)">删除</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div style="margin-top:40px;right:10px; width:100%; text-align:right;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalPageNum">
      </el-pagination>
    </div>
    <!-- 修改信息弹窗-->
    <el-dialog title="问答修改" :visible.sync="changedialogFormVisible">
      <el-form :model="changeinfoform">
        <el-form-item label="标签" :label-width="formLabelWidth">
          <el-input v-model="changeinfoform.label" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changedialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeDialog()">确 定</el-button>
      </div>
    </el-dialog>
    </el-main>
  </div>
</template>

<script>
// import $ from 'jquery'
import { getQALType, addLabel, addQA, delQA, updateQA } from '@/api/common'
export default {
  name: 'personsend',
  data () {
    return {
      currentPage: 1,
      totalPageNum: 0,
      choiceformList: [],
      nameList: [],
      dataList: [],
      tableHeight: '200px',
      border: false,
      selectedRowId: '',
      colShow: false,
      total: 0,
      dialogFormVisible: false,
      changedialogFormVisible: false,
      closeOnClick: false,
      showClose: false,
      pageSize: 10,
      pageNow: 1,
      sQuestion: '',
      formInline: {
        user: '',
        type: '',
        date: ''
      },
      form: {},
      changeinfoform: {
        label: ''
      },
      dialogform: {
        region: ''
      },
      question: '',
      qstypes: [{
        labelId: '',
        labelName: '全部'
      }],
      formLabelWidth: '120px',
      innerVisible: false,
      childtype1: '',
      childtype2: '',
      innertypename: '',
      value: '',
      textarea: '',
      id: '',
      qaType: '',
      userId: '15678902834',
      selectrow: '',
      innerTypeSelect: '',
      changevalue: ''
    }
  },
  created () {
    this.userId = localStorage.getItem('userId')
    this.tableHeight = window.innerHeight - 352 + 'px'
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 352 + 'px'
      })()
    }
  },
  mounted: function () {
    let params = {
      pageSize: this.pageSize,
      pageNow: this.pageNow,
      userId: this.userId
    }
    this.getQAList(params)
  },
  methods: {
    changeQaInfo (row) {
      this.changedialogFormVisible = true
      this.selectrow = row
      this.changeinfoform.c_question = row.question
      this.changeinfoform.c_answer = row.answer
      this.changevalue = row.typeFirst
      this.innerTypeSelect = row.typeFirst
      this.changeinfoform.label = row.labelName
    },
    changeDialog () {
      this.updateQA()
    },
    addQuestionDialog () {
      if (this.question === '') {
        this.$notify({
          title: '提示',
          message: '问题不能为空',
          type: 'warning'
        })
        return
      }
      if (this.textarea === '') {
        this.$notify({
          title: '提示',
          message: '答案不能为空',
          type: 'warning'
        })
        return
      }
      if (this.innerTypeSelect === '') {
        this.$notify({
          title: '提示',
          message: '分类不能为空',
          type: 'warning'
        })
        return
      }
      let params = {
        id: this.uuid(),
        question: this.question,
        answer: this.textarea,
        typeFirst: this.innerTypeSelect,
        typeSecond: this.childtype1,
        typeThird: this.childtype2,
        quesFrom: this.userId,
        quesType: this.userId
      }
      this.addQA(params)
    },
    typechange (e) {
      console.log('选中的值' + e)
      let params = ''
      if (e === '全部') {
        params = {
          pageSize: this.pageSize,
          pageNow: this.pageNow,
          userId: this.userId
        }
      } else {
        params = {
          pageSize: this.pageSize,
          pageNow: this.pageNow,
          qaType: e,
          userId: this.userId
        }
      }
      this.getQAList(params)
    },
    innertypechange (e) {
      console.log('选中的值' + e)
      this.innerTypeSelect = e
    },
    addQuestion () {
      this.question = ''
      this.textarea = ''
      this.innerTypeSelect = ''
      this.value = ''
      this.childtype1 = ''
      this.childtype2 = ''
      this.dialogFormVisible = true
    },
    /* 点击切换先去修改分配状态
    * status 1 是自动分配
    * status 0是全员分配 */
    tableHeaderColor ({ row, column, rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f0f0f0;'
      }
    },
    selectTrigger (val) {
    },
    uuid () { // 生成uid
      let s = []
    	let hexDigits = '0123456789abcdef'
    	for (let i = 0; i < 36; i++) {
    		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    	}
    	s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    	s[8] = s[13] = s[18] = s[23] = '-'

    	let uuid = s.join('')
    	return uuid
    },
    // 修改问答
    updateQA () {
      let url = '/updateLabel'
      let params = {
        id: this.selectrow.labelId,
        label: this.changeinfoform.label
      }
      updateQA(url, params).then(response => {
        if (response.data.ret === 1) {
          this.changedialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          })
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow
          }
          this.getQAList(params)
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '修改失败，请重试',
          type: 'warning'
        })
      })
    },
    open (row) {
      this.$confirm('此操作将删除该问答, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delQA(row)
      }).catch(() => {
        this.$notify({
          title: '提示',
          message: '已取消删除',
          type: 'warning'
        })
      })
    },
    // 删除问答
    delQA (row) {
      let url = '/deletectLabel?id=' + row.labelId
      delQA(url).then(response => {
        if (response.data.ret === 1) {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success'
          })
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow
          }
          this.getQAList(params)
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '删除失败，请重试',
          type: 'warning'
        })
      })
    },
    // 添加问答
    addQA (params) {
      let url = '/addQA'
      addQA(url, params).then(response => {
        // console.log('获取人员列表'+JSON.stringify(response))
        if (response.data.ret === 1) {
          this.$notify({
            title: '成功',
            message: '添加成功',
            type: 'success'
          })
          this.dialogFormVisible = false
          let params = {
            pageSize: this.pageSize,
            pageNow: 0,
            userId: this.userId
          }
          this.getQAList(params)
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '添加失败，请重试',
          type: 'warning'
        })
      })
    },
    // 新增问答
    addLabel () {
      let url = '/addLabel'
      let params = {
        userId: this.userId,
        label: this.innertypename
      }
      addLabel(url, params).then(response => {
        console.log('类型添加成功：' + JSON.stringify(response))
        if (response.data.ret === 1) {
          this.dialogFormVisible = false
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow
          }
          this.getQAList(params)
          this.$notify({
            title: '成功',
            message: '类型添加成功',
            type: 'success'
          })
          this.qstypes.push({
            labelId: '',
            labelName: this.innertypename
          })
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '添加问答分类失败，请重试',
          type: 'warning'
        })
      })
    },
    getQAList: function () {
      let url = '/getAllLabel'
      let params = {
        pageSize: this.pageSize,
        pageNow: this.currentPage
      }
      getQALType(url, params).then(response => {
        if (response.data.ret === 1) {
          this.dataList = response.data.content.data
          this.totalPageNum = response.data.content.total
          // this.totalPageNum = 20
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '获取问答列表失败，请刷新重试',
          type: 'warning'
        })
      })
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.dataList = []
      let params = {
        pageSize: pageSize,
        pageNow: this.pageNow,
        userId: this.userId
      }
      this.getQAList(params)
      console.log(`每页 ${pageSize} 条`)
    },
    handleCurrentChange (currentPage) {
      this.pageNow = currentPage - 1
      this.dataList = []
      let params = {
        pageSize: this.pageSize,
        pageNow: currentPage - 1,
        userId: this.userId
      }
      this.getQAList(params)
      console.log(`当前页: ${currentPage - 1}`)
    },
    showExceptionMessage: function () {
      this.$notify({
        title: '提示',
        message: '系统异常：请联系管理员！',
        type: 'error'
      })
    }

  }
}
</script>
<style scoped>
  .activecolor{
    background-color: #67c23a !important;
    color: #fff;
    width: 67px;
    text-align: center;
  }
  .grey{
    background-color: gainsboro;
    width: 67px;
    text-align: center;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/services/label.vue